<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          :inline="true"
          label-position="right"
          label-width="120px"
          :model="queryForm"
        >
          <el-form-item label="供应商名称">
            <el-input
              v-model="queryForm.user_name"
              placeholder="请输入供应商名称"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item label="写码账号">
            <el-input
              v-model="queryForm.key"
              placeholder="请输入写码账号"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
            <el-button @click="handleAdd" icon="el-icon-plus" type="success" v-hasPermi="['Island:supplier:add']"
              >新增</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="tableCard">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="供应商编号"
          prop="id"
          height="500"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.user_name.slice(0,2) + `${scope.$index + 1 }`}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="供应商名称"
          prop="user_name"
          show-overflow-tooltip
          width="180"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="创建日期"
        >
          <template #default="{ row }">
            {{ transTime(row.insert_time) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="key"
          label="写码账号"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="生效状态"
        >
          <template #default="{ row }">
            <span>{{ row.status == 1 ? '生效' : '未生效' }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="280">
          <template #default="{ row }">
            <el-button
              size="small"
              type="primary"
              v-hasPermi="['Island:supplier:edit']"
              @click="handleEdit(row)"
            >
              编辑
            </el-button>
            <el-button
              size="small"
              type="danger"
              v-hasPermi="['Island:supplier:delete']"
              @click="handleDelete(row)"
              >
              删除
            </el-button>
            <el-button
              size="small"
              type="warning"
              v-hasPermi="['Island:supplier:reset']"
              @click="handleResetPsw(row)"
              >
              重置密码
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getSupList, delSup, resetSupPwdApi } from '@/api/radio'
import { transTime } from '@/utils/transTime'

export default {
  data() {
    return {
      transTime,
      queryForm: {
        page: 1,
        pageSize: 10,
        user_name: '',
        key: '',
      },
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数
      tableData: [],
    }
  },
  created() {
    this.fetchData();
  },
  mounted() {},

  methods: {
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    handleQuery() {
      this.queryForm.page = 1;
      this.fetchData();
    },
    handleAdd(){
      this.$router.push({
        path: '/supplierAdd',
        query: {
          type: 'add'
        }
      })
    },
    handleEdit(row){
      sessionStorage.setItem('supplier', JSON.stringify(row))
      this.$router.push({
        path: '/supplierAdd',
        query: {
          type: 'edit',
          // row: JSON.stringify(row)
        }
      })
    },
    async fetchData() {
      // 这里发请求
      let params = {
        user_name: this.queryForm.user_name,
        key: this.queryForm.key,
        page: this.queryForm.page,
        page_size: this.queryForm.pageSize,
      };
      console.log(params);
      await getSupList(params)
        .then((res) => {
          if (res && res.code) {
            this.tableData = res.data.data_list
            this.total = res.data.total_record; // 总共数量
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleDelete(row){
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delSup({id: row.id}).then(res => {
          if(res && res.code){
            this.fetchData()
          }
        })
      }).catch(() => {
      })
    },
    handleResetPsw(row){
      resetSupPwdApi({
        id: row.id,
        pwd: '123456789'
      }).then(res => {
        if(res && res.code){
        this.$message.success('密码重置成功')
          this.fetchData()
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.tableCard {
  margin-top: 20px;
}
.el-pagination {
  text-align: center;
  margin-top: 10px;
}

</style>